import Dashboard from "../dashboard/modules/dashboard/views/dashboardLayout.vue";
import CheckList from "./components/CheckList";
import ComponentCard from "./components/ComponentCard";
import CheckListView from "./views/CheckListView";
import Auth from "../dashboard/modules/auth/middleware/Auth";

export default [
  {
    path: "/checklist/:type?",
    component: Dashboard,
    children: [
      {
        path: "",
        name: "CheckList",
        component: CheckListView,
        children: [
          {
            path: "",
            name: "PendingList",
            component: CheckList,
            meta: { middleware: [Auth] },
          },
          {
            path: "component/:name",
            name: "ComponentCard",
            component: ComponentCard,
            meta: { middleware: [Auth] },
          },
        ],
      },
    ],
  },
];
